"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ChartContext_1 = require("../../context/ChartContext");
const PathBuilder_1 = require("../../utility/PathBuilder");
const scale_1 = require("../utilities/scale");
function usePath(data, props) {
    const { reverse, width = 100, horizontalMargin = 10 } = props;
    const { mode } = (0, ChartContext_1.useChartData)();
    const scaleX = (0, scale_1.useScale2DY)(reverse);
    const { x, re: y } = data;
    const scaleY = (0, scale_1.getSliceYScale)(y, width, mode, horizontalMargin);
    const pathBuilder = new PathBuilder_1.PathBuilder();
    pathBuilder.moveTo(scaleY(y.at(-1)), scaleX(x.at(-1)));
    for (let i = x.length - 2; i >= 0; i--) {
        pathBuilder.lineTo(scaleY(y[i]), scaleX(x[i]));
    }
    return pathBuilder.toString();
}
function VerticalSliceChart(props) {
    const { horizontalMargin = 10, data, reverse = false } = props;
    const { height, margin, displayerKey } = (0, ChartContext_1.useChartData)();
    const width = margin.left;
    const path = usePath(data, { width, horizontalMargin, reverse });
    const innerHeight = height - margin.bottom - margin.top;
    return ((0, jsx_runtime_1.jsxs)("svg", { viewBox: `0 0 ${height} ${height}`, width: height, height: height, children: [(0, jsx_runtime_1.jsx)("defs", { children: (0, jsx_runtime_1.jsx)("clipPath", { id: `${displayerKey}clip-left`, children: (0, jsx_runtime_1.jsx)("rect", { width: height, height: innerHeight, x: "0", y: margin.top }) }) }), (0, jsx_runtime_1.jsx)("g", { clipPath: `url(#${displayerKey}clip-left)`, children: (0, jsx_runtime_1.jsx)("path", { className: "line", stroke: "red", fill: "none", d: path }) })] }));
}
exports.default = VerticalSliceChart;
